package compose.assets.svg

import androidx.compose.ui.graphics.Color
import androidx.compose.ui.graphics.PathFillType.Companion.NonZero
import androidx.compose.ui.graphics.SolidColor
import androidx.compose.ui.graphics.StrokeCap.Companion.Butt
import androidx.compose.ui.graphics.StrokeJoin.Companion.Miter
import androidx.compose.ui.graphics.vector.ImageVector
import androidx.compose.ui.graphics.vector.ImageVector.Builder
import androidx.compose.ui.graphics.vector.path
import androidx.compose.ui.unit.dp
import compose.assets.Svg

public val Svg.UserOutline: ImageVector
    get() {
        if (_userOutline != null) {
            return _userOutline!!
        }
        _userOutline = Builder(name = "UserOutline", defaultWidth = 24.0.dp, defaultHeight =
                24.0.dp, viewportWidth = 17.0f, viewportHeight = 17.0f).apply {
            path(fill = SolidColor(Color(0xFF000000)), stroke = null, strokeLineWidth = 0.0f,
                    strokeLineCap = Butt, strokeLineJoin = Miter, strokeLineMiter = 4.0f,
                    pathFillType = NonZero) {
                moveTo(0.0f, 14.1794f)
                lineTo(0.0f, 12.3269f)
                curveTo(0.0f, 11.8974f, 0.1108f, 11.5141f, 0.3325f, 11.177f)
                curveTo(0.5542f, 10.84f, 0.8503f, 10.5777f, 1.2207f, 10.3903f)
                curveTo(2.0127f, 10.0029f, 2.809f, 9.7043f, 3.6098f, 9.4944f)
                curveTo(4.4105f, 9.2844f, 5.2906f, 9.1795f, 6.25f, 9.1795f)
                curveTo(7.2094f, 9.1795f, 8.0894f, 9.2844f, 8.8902f, 9.4944f)
                curveTo(9.6909f, 9.7043f, 10.4873f, 10.0029f, 11.2792f, 10.3903f)
                curveTo(11.6497f, 10.5777f, 11.9457f, 10.84f, 12.1674f, 11.177f)
                curveTo(12.3891f, 11.5141f, 12.4999f, 11.8974f, 12.4999f, 12.3269f)
                lineTo(12.4999f, 14.1794f)
                lineTo(0.0f, 14.1794f)
                lineTo(0.0f, 14.1794f)
                moveTo(14.1666f, 14.1794f)
                lineTo(14.1666f, 12.2243f)
                curveTo(14.1666f, 11.6773f, 14.0327f, 11.156f, 13.7648f, 10.6604f)
                curveTo(13.4969f, 10.1648f, 13.117f, 9.7395f, 12.625f, 9.3846f)
                curveTo(13.1837f, 9.4679f, 13.7142f, 9.5969f, 14.2163f, 9.7716f)
                curveTo(14.7184f, 9.9463f, 15.1976f, 10.1528f, 15.6538f, 10.391f)
                curveTo(16.0843f, 10.6207f, 16.4168f, 10.8914f, 16.6513f, 11.2032f)
                curveTo(16.8859f, 11.5149f, 17.0031f, 11.8553f, 17.0031f, 12.2243f)
                lineTo(17.0031f, 14.1794f)
                lineTo(14.1666f, 14.1794f)
                lineTo(14.1666f, 14.1794f)
                moveTo(6.25f, 7.8333f)
                curveTo(5.4455f, 7.8333f, 4.7583f, 7.5483f, 4.1883f, 6.9783f)
                curveTo(3.6183f, 6.4083f, 3.3333f, 5.7211f, 3.3333f, 4.9166f)
                curveTo(3.3333f, 4.1122f, 3.6183f, 3.4249f, 4.1883f, 2.855f)
                curveTo(4.7583f, 2.285f, 5.4455f, 2.0f, 6.25f, 2.0f)
                curveTo(7.0545f, 2.0f, 7.7417f, 2.285f, 8.3117f, 2.855f)
                curveTo(8.8816f, 3.4249f, 9.1666f, 4.1122f, 9.1666f, 4.9166f)
                curveTo(9.1666f, 5.7211f, 8.8816f, 6.4083f, 8.3117f, 6.9783f)
                curveTo(7.7417f, 7.5483f, 7.0545f, 7.8333f, 6.25f, 7.8333f)
                lineTo(6.25f, 7.8333f)
                moveTo(13.4454f, 4.9166f)
                curveTo(13.4454f, 5.7211f, 13.1598f, 6.4083f, 12.5886f, 6.9783f)
                curveTo(12.0175f, 7.5483f, 11.3308f, 7.8333f, 10.5288f, 7.8333f)
                curveTo(10.4348f, 7.8333f, 10.3151f, 7.8226f, 10.1698f, 7.8012f)
                curveTo(10.0245f, 7.7799f, 9.9049f, 7.7564f, 9.8109f, 7.7307f)
                curveTo(10.1395f, 7.3356f, 10.392f, 6.8973f, 10.5685f, 6.4158f)
                curveTo(10.745f, 5.9342f, 10.8333f, 5.4342f, 10.8333f, 4.9156f)
                curveTo(10.8333f, 4.3971f, 10.7433f, 3.899f, 10.5632f, 3.4215f)
                curveTo(10.3832f, 2.9439f, 10.1324f, 2.5043f, 9.8109f, 2.1026f)
                curveTo(9.9305f, 2.0598f, 10.0502f, 2.032f, 10.1698f, 2.0192f)
                curveTo(10.2895f, 2.0064f, 10.4091f, 2.0f, 10.5288f, 2.0f)
                curveTo(11.3308f, 2.0f, 12.0175f, 2.285f, 12.5886f, 2.855f)
                curveTo(13.1598f, 3.4249f, 13.4454f, 4.1122f, 13.4454f, 4.9166f)
                lineTo(13.4454f, 4.9166f)
                moveTo(1.25f, 12.9294f)
                lineTo(11.25f, 12.9294f)
                lineTo(11.25f, 12.3269f)
                curveTo(11.25f, 12.1527f, 11.2064f, 11.9978f, 11.1194f, 11.8621f)
                curveTo(11.0323f, 11.7264f, 10.8942f, 11.6079f, 10.7051f, 11.5063f)
                curveTo(10.0192f, 11.1527f, 9.313f, 10.8848f, 8.5865f, 10.7027f)
                curveTo(7.86f, 10.5205f, 7.0812f, 10.4294f, 6.25f, 10.4294f)
                curveTo(5.4188f, 10.4294f, 4.6399f, 10.5205f, 3.9134f, 10.7027f)
                curveTo(3.1869f, 10.8848f, 2.4807f, 11.1527f, 1.7948f, 11.5063f)
                curveTo(1.6057f, 11.6079f, 1.4677f, 11.7264f, 1.3806f, 11.8621f)
                curveTo(1.2935f, 11.9978f, 1.25f, 12.1527f, 1.25f, 12.3269f)
                lineTo(1.25f, 12.9294f)
                lineTo(1.25f, 12.9294f)
                moveTo(6.25f, 6.5833f)
                curveTo(6.7083f, 6.5833f, 7.1007f, 6.4201f, 7.4271f, 6.0937f)
                curveTo(7.7534f, 5.7673f, 7.9166f, 5.375f, 7.9166f, 4.9166f)
                curveTo(7.9166f, 4.4583f, 7.7534f, 4.0659f, 7.4271f, 3.7396f)
                curveTo(7.1007f, 3.4132f, 6.7083f, 3.25f, 6.25f, 3.25f)
                curveTo(5.7916f, 3.25f, 5.3993f, 3.4132f, 5.0729f, 3.7396f)
                curveTo(4.7465f, 4.0659f, 4.5833f, 4.4583f, 4.5833f, 4.9166f)
                curveTo(4.5833f, 5.375f, 4.7465f, 5.7673f, 5.0729f, 6.0937f)
                curveTo(5.3993f, 6.4201f, 5.7916f, 6.5833f, 6.25f, 6.5833f)
                lineTo(6.25f, 6.5833f)
                moveTo(6.25f, 12.9294f)
                lineTo(6.25f, 12.9294f)
                lineTo(6.25f, 12.9294f)
                lineTo(6.25f, 12.9294f)
                lineTo(6.25f, 12.9294f)
                lineTo(6.25f, 12.9294f)
                lineTo(6.25f, 12.9294f)
                lineTo(6.25f, 12.9294f)
                lineTo(6.25f, 12.9294f)
                lineTo(6.25f, 12.9294f)
                lineTo(6.25f, 12.9294f)
                lineTo(6.25f, 12.9294f)
                lineTo(6.25f, 12.9294f)
                moveTo(6.25f, 4.9166f)
                lineTo(6.25f, 4.9166f)
                lineTo(6.25f, 4.9166f)
                lineTo(6.25f, 4.9166f)
                lineTo(6.25f, 4.9166f)
                lineTo(6.25f, 4.9166f)
                lineTo(6.25f, 4.9166f)
                lineTo(6.25f, 4.9166f)
                lineTo(6.25f, 4.9166f)
                lineTo(6.25f, 4.9166f)
            }
        }
        .build()
        return _userOutline!!
    }

private var _userOutline: ImageVector? = null
